




























import { Component, Ref, Vue } from 'vue-property-decorator';
import { $http } from '@/axios';
import { ILog } from '@/views/data/migration/socket/types';
import MigrationSocket from '@/views/data/migration/socket/index';
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { sleep } from '@/utils/helper';

@Component({
  components: { DynamicScroller, DynamicScrollerItem },
})
export default class DemoSocket extends Vue {
  @Ref('scroller') public scrollerRef!: HTMLFormElement;

  public id = 0;
  public oldScrollTop = 0;
  public scrollFlag = true;
  public items: ILog[] = [];
  public websocket!: MigrationSocket;

  // 滚动到底部
  public onScrollerUpdate() {
    const el = this.scrollerRef.$el;
    const scrollTop = el.scrollTop;
    const scrollStep = scrollTop - this.oldScrollTop;
    if (scrollTop - this.oldScrollTop > 0) {
      this.oldScrollTop = scrollTop;
    }
    this.scrollFlag = scrollStep > -30;
  }

  public getRandomInt(min: number, max: number) {
    const minVal = Math.ceil(min);
    const maxVal = Math.floor(max);
    const radix = maxVal - minVal + 1;
    return Math.floor(Math.random() * radix) + minVal;
  }

  public setColor(record: any) {
    return {
      'orange--text': record.type === 'debug',
      'grey--text': record.type === 'tips',
      'blue--text': record.type === 'warn',
      'red--text': record.type === 'exception' || record.type === 'error',
      'font-weight-bold': record.type === 'exception',
    };
  }

  public async addData() {
    const text = `
      The prerender props can be set as the number of items to render on the server inside the virtual scroller:
      This works just like the RecycleScroller, but it can render items with unknown sizes!
    `;
    for (let i = 0; i < 200; i++) {
      const end = this.getRandomInt(12, 300);
      await sleep(0.5);
      this.items.push({ id: i, type: 'info', text: text.slice(10, end) });
      if (this.scrollFlag) {
        this.$nextTick(() => this.scrollerRef?.scrollToBottom());
      }
    }
  }

  public async onStart() {
    const checkParams = { migrationType: 'design', uuid: '116a745ea1864000' };
    const isRunning =  await $http.post('/v1/migration/status/check', checkParams);
    const params = { env: 'dev', migrationType: 'design', uuid: '116a745ea1864000' };
    this.websocket = new MigrationSocket(params);
    this.websocket.test(this.onLog);
    // isRunning ? this.websocket.reconnect(this.onLog) : this.websocket.connect(this.onLog);
  }

  public onEnd() {
    this.websocket.disconnect();
  }

  public onLog(log: ILog) {
    this.id++;
    this.items.push({ id: this.id, ...log });
  }


}
